<div class="home-container">
  <div class="welcome-section">
    <h1>Welcome to Support Portal</h1>
    <p>Access patient and teammate information quickly and securely.</p>
    <div class="action-buttons">
      <button mat-raised-button color="primary" routerLink="/search">
        <mat-icon>search</mat-icon>
        Patient Search
      </button>
    </div>
  </div>
</div>
